<template>
  <div class="base-form">
    <van-form ref="formRef"
              :label-width="labelWidth"
              :label-align="labelAlign"
              :colon="colon"
              :show-error="showError"
              :show-error-message="showErrorMessage"
              @submit="handleSubmit"
              @failed="onFailed">
      <template v-for="(item, index) in formItems">
        <template v-if="item.showItem === false ? false: true">
          <!-- 文本输入框 -->
          <van-field v-if="['text','textarea','password'].includes(item.type)"
                     :key="index"
                     v-model="formData[item.prop]"
                     :name="item.prop"
                     :label="item.label"
                     :type="item.type"
                     :placeholder="item.placeholder || `请输入${item.label}`"
                     :rules="item.rules"
                     :required="item.required"
                     :disabled="item.disabled"
                     :readonly="item.readonly"
                     :rows="item.type === 'textarea' ? 4 : undefined"
                     :autosize="item.type === 'textarea'"
                     :input-align="inputAlign"
                     :clearable="item.clearable"
                     :size="size"
                     v-bind="item"
                     v-on="item.on" />

          <!-- 数字输入框 -->
          <van-field v-else-if="item.type === 'number'"
                     :key="index"
                     v-model.number="formData[item.prop]"
                     :name="item.prop"
                     :label="item.label"
                     type="digit"
                     :placeholder="item.placeholder || `请输入${item.label}`"
                     :rules="item.rules"
                     :required="item.required"
                     :disabled="item.disabled"
                     :readonly="item.readonly"
                     :input-align="inputAlign"
                     :clearable="item.clearable"
                     :size="size"
                     v-bind="item"
                     v-on="item.on" />

          <!-- 选择器 -->
          <van-field v-else-if="item.type === 'select'"
                     :key="index"
                     :value="formData[item.prop]"
                     :name="item.prop"
                     :label="item.label"
                     :placeholder="item.placeholder || `请选择${item.label}`"
                     :rules="item.rules"
                     :required="item.required"
                     :disabled="item.disabled"
                     readonly
                     :input-align="inputAlign"
                     is-link
                     :size="size"
                     @click="showPicker(item, index)">
            <template #input>
              <div class="select-value" v-if="formData[item.prop]">
                {{ getOptionLabel(item, formData[item.prop]) }}
              </div>
              <div class="select-placeholder" v-else>
                {{ item.placeholder || `请选择${item.label}` }}
              </div>
            </template>
          </van-field>

          <!-- 日期选择器 (修复时间类型处理) -->
          <van-field v-else-if="item.type === 'date'"
                     :key="index"
                     :value="formData[item.prop]"
                     :name="item.prop"
                     :label="item.label"
                     :placeholder="item.placeholder || `请选择${item.label}`"
                     :rules="item.rules"
                     :required="item.required"
                     :disabled="item.disabled"
                     readonly
                     :input-align="inputAlign"
                     is-link
                     :size="size"
                     @click="showDatePicker(item, index)">
            <template #input>
              <div class="date-value" v-if="formData[item.prop]">
                {{ formatDateValue(formData[item.prop], item.dateType) }}
              </div>
              <div class="select-placeholder" v-else>
                {{ item.placeholder || `请选择${item.label}` }}
              </div>
            </template>
          </van-field>

          <!-- 开关 -->
          <van-field v-else-if="item.type === 'switch'"
                     :key="index"
                     :name="item.prop"
                     :label="item.label"
                     :rules="item.rules"
                     :required="item.required"
                     :size="size">
            <template #input>
              <van-switch v-model="formData[item.prop]"
                          :size="item.size || '20px'"
                          :disabled="item.disabled"
                          v-on="item.on" />
            </template>
          </van-field>

          <!-- 复选框 -->
          <van-field v-else-if="item.type === 'checkbox'"
                     :key="index"
                     :name="item.prop"
                     :label="item.label"
                     :rules="item.rules"
                     :required="item.required"
                     :size="size">
            <template #input>
              <van-checkbox v-model="formData[item.prop]"
                            :disabled="item.disabled"
                            :shape="item.shape || 'square'"
                            :checked-color="item.checkedColor"
                            v-on="item.on">
                {{ item.checkboxLabel }}
              </van-checkbox>
            </template>
          </van-field>

          <!-- 复选框组 -->
          <van-field v-else-if="item.type === 'checkbox-group'"
                     :key="index"
                     :name="item.prop"
                     :label="item.label"
                     :rules="item.rules"
                     :required="item.required"
                     :size="size">
            <template #input>
              <van-checkbox-group v-model="formData[item.prop]"
                                  :disabled="item.disabled"
                                  :direction="item.direction || 'horizontal'"
                                  :max="item.max"
                                  v-on="item.on">
                <van-checkbox v-for="(option, optionIndex) in item.options"
                              :key="optionIndex"
                              :name="option[(item.optionProps && item.optionProps.id) || 'id']"
                              :shape="item.shape || 'square'"
                              :checked-color="item.checkedColor">
                  {{ option[(item.optionProps && item.optionProps.name) || 'name'] }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>

          <!-- 单选框组 -->
          <van-field v-else-if="item.type === 'radio-group'"
                     :key="index"
                     :name="item.prop"
                     :label="item.label"
                     :rules="item.rules"
                     :required="item.required"
                     :size="size">
            <template #input>
              <van-radio-group v-model="formData[item.prop]"
                               :disabled="item.disabled"
                               :direction="item.direction || 'horizontal'"
                               v-on="item.on">
                <van-radio v-for="(option, optionIndex) in item.options"
                           :key="optionIndex"
                           :name="option[(item.optionProps && item.optionProps.id) || 'id']"
                           :checked-color="item.checkedColor">
                  {{ option[(item.optionProps && item.optionProps.name) || 'name'] }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 步进器 -->
          <van-field v-else-if="item.type === 'stepper'"
                     :key="index"
                     :name="item.prop"
                     :label="item.label"
                     :rules="item.rules"
                     :required="item.required"
                     :size="size">
            <template #input>
              <van-stepper v-model="formData[item.prop]"
                           :min="item.min !== undefined ? item.min : 1"
                           :max="item.max !== undefined ? item.max : 100"
                           :step="item.step || 1"
                           :integer="item.integer !== undefined ? item.integer : true"
                           :disabled="item.disabled"
                           :button-size="item.buttonSize || 'normal'"
                           :input-width="item.inputWidth || '32px'"
                           v-on="item.on" />
            </template>
          </van-field>

          <!-- 评分 -->
          <van-field v-else-if="item.type === 'rate'"
                     :key="index"
                     :name="item.prop"
                     :label="item.label"
                     :rules="item.rules"
                     :required="item.required"
                     :size="size">
            <template #input>
              <van-rate v-model="formData[item.prop]"
                        :count="item.count || 5"
                        :size="item.size || '20px'"
                        :gutter="item.gutter"
                        :color="item.color || '#ffd21e'"
                        :void-color="item.voidColor || '#c8c9cc'"
                        :void-icon="item.voidIcon || 'star'"
                        :icon="item.icon || 'star'"
                        :allow-half="item.allowHalf"
                        :readonly="item.readonly"
                        :disabled="item.disabled"
                        v-on="item.on" />
            </template>
          </van-field>

          <!-- 滑块 -->
          <van-field v-else-if="item.type === 'slider'"
                     :key="index"
                     :name="item.prop"
                     :label="item.label"
                     :rules="item.rules"
                     :required="item.required"
                     :size="size">
            <template #input>
              <div class="slider-container">
                <van-slider v-model="formData[item.prop]"
                            :min="item.min !== undefined ? item.min : 0"
                            :max="item.max !== undefined ? item.max : 100"
                            :step="item.step || 1"
                            :bar-height="item.barHeight || '2px'"
                            :active-color="item.activeColor || '#1989fa'"
                            :inactive-color="item.inactiveColor || '#e5e5e5'"
                            :disabled="item.disabled"
                            :vertical="item.vertical"
                            v-on="item.on">
                  <template #button>
                    <div v-if="item.showValue"
                         class="custom-button">
                      {{ formData[item.prop] }}
                    </div>
                  </template>
                </van-slider>
              </div>
            </template>
          </van-field>

          <!-- 自定义插槽 -->
          <slot v-else-if="item.type === 'slot'"
                :name="item.slotName"
                :item="item"
                :value="formData[item.prop]"
                :index="index" />
        </template>
      </template>

      <!-- 表单操作按钮 -->
      <div class="form-actions">
        <slot name="actions">
          <van-button block
                      type="info"
                      native-type="submit"
                      :loading="submitting"
                      class="submit-btn">
            {{ submitText }}
          </van-button>
        </slot>
      </div>
    </van-form>

    <!-- 选择器弹窗 -->
    <van-popup v-model="showPickerPopup"
               position="bottom">
      <van-picker v-if="showPickerPopup"
                  show-toolbar
                  :title="currentPicker?.label"
                  :columns="currentPicker?.options"
                  :default-index="pickerOptionsIndex"
                  @confirm="onPickerConfirm"
                  @cancel="showPickerPopup = false" />
    </van-popup>

    <!-- 日期选择器弹窗 (修复时间类型处理) -->
    <van-popup v-model="showDatePickerPopup"
               position="bottom">
      <van-datetime-picker v-if="showDatePickerPopup"
                           v-model="currentDateValue"
                           :type="currentDatePicker?.dateType || 'date'"
                           :title="currentDatePicker?.label"
                           :min-date="currentDatePicker?.minDate"
                           :max-date="currentDatePicker?.maxDate"
                           :formatter="dateFormatter"
                           @confirm="onDateConfirm"
                           @cancel="showDatePickerPopup = false" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'BaseFormM',

  props: {
    // 表单配置项
    formItems: {
      type: Array,
      required: true,
      default: () => []
    },

    // 表单数据对象
    modelValue: {
      type: Object,
      required: true,
      default: () => ({})
    },

    // 标签宽度
    labelWidth: {
      type: String,
      default: '60px'
    },

    // 标签对齐方式
    labelAlign: {
      type: String,
      default: 'right'
    },

    // 是否显示冒号
    colon: {
      type: Boolean,
      default: true
    },

    // 输入框内容对齐方式
    inputAlign: {
      type: String,
      default: 'left'
    },

    // 是否在输入框下方显示错误信息
    showError: {
      type: Boolean,
      default: true
    },

    // 是否显示错误提示文案
    showErrorMessage: {
      type: Boolean,
      default: true
    },

    // 提交按钮文本
    submitText: {
      type: String,
      default: '提交'
    },
    size: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      formData: {},
      submitting: false,
      showPickerPopup: false,
      showDatePickerPopup: false,
      currentPicker: null,
      currentPickerIndex: null,
      currentDatePicker: null,
      pickerOptionsIndex: null,
      currentDateValue: new Date()
    }
  },

  watch: {
    modelValue: {
      handler(newVal) {
        this.formData = { ...newVal };
      },
      deep: true
    },

    formData: {
      handler(newVal) {
        // 防止无限循环，简单比较一下
        if (JSON.stringify(newVal) !== JSON.stringify(this.modelValue)) {
          this.$emit('update:modelValue', newVal);
        }
      },
      deep: true
    }
  },
  created() {
    this.formData = { ...this.modelValue }
  },
  methods: {
    // 显示选择器
    showPicker(item, index) {
      if (item.disabled) return;
      this.currentPicker = item;
      this.currentPickerIndex = index;
      this.pickerOptionsIndex = item.options.findIndex(opt => opt.value === this.formData[item.prop]);
      this.showPickerPopup = true;
    },

    // 确认选择器选项
    onPickerConfirm(value) {
      if (!this.currentPicker) return;
      const prop = this.currentPicker.prop;

      // 处理选择器返回值
      if (typeof value === 'object' && value !== null) {
        // 如果选项是对象，存储值
        this.formData[prop] = value.value;
      } else {
        // 如果选项是基本类型，直接存储
        this.formData[prop] = value;
      }

      this.showPickerPopup = false;
    },

    // 获取选择项的显示标签 (修复显示问题)
    getOptionLabel(item, value) {
      if (!item.options || value === undefined || value === null) return '';

      // 支持选项值为对象和基本类型
      const option = item.options.find(opt => {
        if (typeof opt === 'object' && opt !== null) {
          return opt.value === value;
        }
        return opt === value;
      });

      if (option) {
        return typeof option === 'object' ? option.text : option;
      }
      return '';
    },

    // 显示日期选择器
    showDatePicker(item) {
      if (item.disabled) return;
      this.currentDatePicker = item;
      if (item.dateType === 'time') {
        this.currentDateValue = this.formData[item.prop];
      } else {
        // 处理日期初始值
        if (this.formData[item.prop]) {
          if (this.formData[item.prop] instanceof Date) {
            this.currentDateValue = this.formData[item.prop];
          } else {
            // 尝试将字符串转换为Date对象
            const date = new Date(this.formData[item.prop]);
            this.currentDateValue = isNaN(date.getTime()) ? new Date() : date;
          }
        } else {
          this.currentDateValue = new Date();
        }
      }


      this.showDatePickerPopup = true;
    },

    // 确认日期选择 (修复时间类型处理)
    onDateConfirm(value) {
      const prop = this.currentDatePicker.prop;

      // 根据日期类型格式化
      if (this.currentDatePicker.dateType === 'time') {
        // 时间类型 - 直接赋值
        this.formData[prop] = value
      } else if (this.currentDatePicker.dateType === 'datetime') {
        // 日期时间类型
        this.formData[prop] = this.formatDate(value, 'datetime');
      } else {
        // 日期类型
        this.formData[prop] = this.formatDate(value, 'date');
      }

      this.showDatePickerPopup = false;
    },

    // 格式化日期值
    formatDateValue(value, dateType) {
      if (!value) return '';

      if (value instanceof Date) {
        return this.formatDate(value, dateType);
      }

      // 如果是字符串，直接返回（适用于时间类型）
      if (dateType === 'time') {
        return value;
      }

      // 尝试转换为Date对象
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return this.formatDate(date, dateType);
      }

      return value; // 如果不是有效日期，返回原值
    },

    // 日期格式化函数
    formatDate(date, dateType) {
      const year = date.getFullYear();
      const month = this.padZero(date.getMonth() + 1);
      const day = this.padZero(date.getDate());
      const hours = this.padZero(date.getHours());
      const minutes = this.padZero(date.getMinutes());
      // const seconds = this.padZero(date.getSeconds());

      switch (dateType) {
        case 'time':
          return `${hours}:${minutes}`;
        case 'datetime':
          return `${year}-${month}-${day} ${hours}:${minutes}`;
        default:
          return `${year}-${month}-${day}`;
      }
    },

    // 补零函数
    padZero(num) {
      return num < 10 ? `0${num}` : num;
    },

    // 日期选择器格式化
    dateFormatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`;
      } else if (type === 'day') {
        return `${value}日`;
      } else if (type === 'hour') {
        return `${value}时`;
      } else if (type === 'minute') {
        return `${value}分`;
      }
      return value;
    },

    // 提交表单
    handleSubmit() {
      this.submitting = true;
      this.$emit('submit', this.formData, () => {
        this.submitting = false;
      });
    },

    // 表单验证失败
    onFailed(errorInfo) {
      this.$emit('failed', errorInfo);
    },

    // 重置表单
    resetForm() {
      this.$refs.formRef.resetValidation();
      this.$emit('reset');
    },

    // 验证表单
    validate() {
      return this.$refs.formRef.validate();
    }
  }
};
</script>

<style scoped>
.base-form {
  user-select: none;
}
.form-actions {
  padding: 12px 0;
}

/* 滑块容器样式 */
.slider-container {
  padding: 10px 0;
  width: 100%;
}

/* 滑块自定义按钮样式 */
.custom-button {
  width: 24px;
  height: 24px;
  background-color: #1989fa;
  border-radius: 50%;
  color: #fff;
  font-size: 10px;
  line-height: 24px;
  text-align: center;
}

/* 复选框组和单选框组样式 */
.van-checkbox-group,
.van-radio-group {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.van-checkbox-group .van-checkbox,
.van-radio-group .van-radio {
  margin-right: 10px;
  margin-bottom: 5px;
}

/* 评分组件样式 */
.van-rate {
  display: flex;
  align-items: center;
}

.select-placeholder{
  color: #c7c6c6;
}
</style>